import { IAnalysisContactForm } from '@module/shared';

export async function UploadSparePartsDetailsService(sparePartsUploadID: string, details: IAnalysisContactForm): Promise<IAnalysisContactForm> {
  const url = `${environmentSettings.webapiUrl}/v1/Upload/Details`;
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  // const formData = new FormData();
  // formData.append('details', details);

  const options = {
    headers,
    method: 'post',
    body: JSON.stringify({SparePartsUploadID: sparePartsUploadID, ...details})
  };
  const response = await fetch(url, options);
  const contentType = response.headers.get('content-type');

  if (response.ok && contentType && contentType.indexOf('application/json') !== -1) {
    const json = await response.json();
    return json;
  } else {
    return Promise.reject(`System error: ${response.status} ${response.statusText}`);
  }
}
